import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { IconButton, useTheme } from '@mui/material';

interface CheckboxButtonProps {
    completed: boolean;
    onToggle: (e: React.MouseEvent) => void;
}

export const CheckboxButton: React.FC<CheckboxButtonProps> = ({ completed, onToggle }) => {
    const theme = useTheme();

    return (
        <IconButton
            size="small"
            onClick={onToggle}
            onDoubleClick={(e) => e.stopPropagation()}
            sx={{
                p: 0.5,
                color: 'inherit',
                '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                },
                [theme.breakpoints.down('sm')]: {
                    display: 'none',
                },
            }}
        >
            {completed ? (
                <CheckBox fontSize="small" />
            ) : (
                <CheckBoxOutlineBlank fontSize="small" />
            )}
        </IconButton>
    );
}; 